<template>
  <div>
    <section slot="pdf-content" ref="html2pdf">
      <div v-if="userData && userData._id" id="prestige" ref="prestigeDocument">
        <vs-row class="wrapperr">
          <div class="sidebar" :style="{ backgroundColor: colorObj }">
            <div class="heading-image">
              <div v-if="userData.profilePictureUrl" class="profile-pic">
                <img
                  :src="
                    userProfilePicture
                      ? userProfilePicture
                      : constants.s3Bucket +
                        '/editor/profile-pictures/' +
                        userData.profilePictureUrl
                  "
                />
              </div>
              <div v-else class="profile-pic">
                <img src="@/assets/images/icons/gender/default.png" />
              </div>
              <div
                class="title"
                data-wow-delay="0.1s"
                style="
                  visibility: visible;
                  animation-delay: 0.1s;
                  animation-name: fadeIn;
                "
              >
                <h2 class="text-white">
                  {{ userData.firstName }} {{ userData.lastName }}
                </h2>
                <!-- title name -->
                <span>{{ userData.profession }}</span>
                <!-- tagline -->
              </div>
            </div>
            <div
              v-if="userData.careerObjective"
              class="summary"
              :style="{ backgroundColor: colorObj }"
            >
              <div class="sidebar-title">Career Objective</div>
              <p class="text-white text-justify">
                {{ userData.careerObjective }}
              </p>
            </div>
            <div
              v-if="userData.email"
              class="contact"
              :style="{ backgroundColor: colorObj }"
            >
              <div class="sidebar-title">
                {{ $t("editor.template.prestige.contactInfo") }}
              </div>
              <div v-if="userData.address" class="address">
                <div class="icon-container">
                  <feather-icon icon="HomeIcon" />
                </div>
                {{ userData.address }}
              </div>
              <div v-if="userData.contactNumber" class="number">
                <div class="icon-container">
                  <feather-icon icon="PhoneIcon" />
                </div>
                {{ userData.contactNumber }}
              </div>
              <div v-if="userData.email" class="email">
                <div class="icon-container">
                  <feather-icon icon="MailIcon" />
                </div>
                {{ userData.email }}
              </div>
              <div class="social">
                <div class="social-box">
                  <a
                    v-if="userData.personalWebsite"
                    :href="userData.personalWebsite"
                    target="_blank"
                  >
                    <div class="icon" style="float: left; margin-right: 15px">
                      <img
                        class="social-icon"
                        src="@/assets/images/socialProfileLogos/globe.svg"
                        alt=""
                      />
                    </div>
                  </a>
                </div>
                <div class="social-box">
                  <a
                    v-if="userData.facebookProfile"
                    :href="userData.facebookProfile"
                    target="_blank"
                  >
                    <div class="icon" style="float: left; margin-right: 15px">
                      <img
                        class="social-icon"
                        src="@/assets/images/socialProfileLogos/facebook.svg"
                        alt=""
                      />
                    </div>
                  </a>
                </div>
                <div class="social-box">
                  <a
                    v-if="userData.twitterProfile"
                    :href="userData.twitterProfile"
                    target="_blank"
                  >
                    <div class="icon" style="float: left; margin-right: 15px">
                      <img
                        class="social-icon"
                        src="@/assets/images/socialProfileLogos/twitter.svg"
                        alt=""
                      />
                    </div>
                  </a>
                </div>
                <div class="social-box">
                  <a
                    v-if="userData.linkedinProfile"
                    :href="userData.linkedinProfile"
                    target="_blank"
                  >
                    <div class="icon" style="float: left; margin-right: 15px">
                      <img
                        class="social-icon"
                        src="@/assets/images/socialProfileLogos/linkedin.svg"
                        alt=""
                      />
                    </div>
                  </a>
                </div>
                <div class="social-box">
                  <a
                    v-if="userData.skypeProfile"
                    :href="userData.skypeProfile"
                    target="_blank"
                  >
                    <div class="icon" style="float: left; margin-right: 15px">
                      <img
                        class="social-icon skype-icon"
                        src="@/assets/images/socialProfileLogos/skype.svg"
                        alt=""
                      />
                    </div>
                  </a>
                </div>
                <div class="social-box">
                  <div
                    v-if="userData.discordProfile"
                    @click="copyProfile(userData.discordProfile)"
                    target="_blank"
                  >
                    <div class="icon" style="float: left; margin-right: 15px">
                      <img
                        class="social-icon"
                        src="@/assets/images/socialProfileLogos/discord.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="editorData.extraCurricular">
              <div
                v-if="
                  editorData.extraCurricular.languages &&
                  editorData.extraCurricular.languages.length
                "
                class="skills"
                :style="{ backgroundColor: colorObj }"
              >
                <div class="sidebar-title">
                  {{ $t("editor.template.prestige.languages") }}
                </div>
                <ul>
                  <li
                    v-for="(language, index) in editorData.extraCurricular
                      .languages"
                    :key="index"
                    :style="{ backgroundColor: colorObj }"
                  >
                    {{ language.title.label.toUpperCase() }}
                    <vs-progress
                      :percent="(language.level * 100) / 5"
                      color="#FFFFFF"
                      >primary</vs-progress
                    >
                  </li>
                </ul>
              </div>

              <div
                v-if="
                  editorData.extraCurricular.skills &&
                  editorData.extraCurricular.skills.length
                "
                class="skills"
                :style="{ backgroundColor: colorObj }"
              >
                <div class="sidebar-title">
                  {{ $t("editor.template.prestige.skills") }}
                </div>
                <ul>
                  <li
                    v-for="(skill, index) in editorData.extraCurricular.skills"
                    :key="index"
                    :style="{ backgroundColor: colorObj }"
                  >
                    {{ skill.title.toUpperCase() }}
                    <vs-progress
                      :percent="(skill.level * 100) / 5"
                      color="#FFFFFF"
                      >primary</vs-progress
                    >
                  </li>
                </ul>
              </div>

              <div
                v-if="
                  editorData.extraCurricular.hobbies &&
                  editorData.extraCurricular.hobbies.length
                "
                class="skills"
              >
                <div class="sidebar-title">
                  {{ $t("editor.template.prestige.hobbies") }}
                </div>
                <div class="main-box flex flex-wrap gap-2">
                  <div
                    v-for="(hobby, index) in editorData.extraCurricular.hobbies"
                    :key="index"
                  >
                    <vs-icon
                      v-if="hobby.icon"
                      :icon="hobby.icon"
                      size="medium"
                    />
                    <!-- <i class="fa fa-book fa-3x"></i> -->
                    <h3 class="text-white">{{ hobby.metaData.label }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="content">
            <div
              v-if="editorData.careerHistory && editorData.careerHistory.length"
              class="experience"
            >
              <img
                class="mr-3 float-left"
                src="@/assets/images/icons/editor-icons/inactive/career-history.svg"
              />
              <div class="content-title">
                {{ $t("editor.template.prestige.careerHistory") }}
              </div>
              <div
                v-for="(ch, index) in editorData.careerHistory"
                :key="index"
                class="main-box"
              >
                <div v-if="ch.company">
                  <div
                    v-for="(pr, indexPr) in ch.promotions"
                    :key="indexPr"
                    class="main-box"
                  >
                    <h2 :style="{ color: colorObj }">{{ pr.title }}</h2>
                    <h3>{{ ch.company }}</h3>
                    <h4 v-if="pr.startDate">
                      <span v-if="pr.startDate">{{
                        formatDate(pr.startDate)
                      }}</span>
                      <span v-if="pr.startDate"> - </span>
                      <span v-if="pr.currentlyActive">Present</span>
                      <span v-else-if="pr.endDate">{{
                        formatDate(pr.endDate)
                      }}</span>
                    </h4>
                    <p></p>
                    <ul>
                      <li
                        v-for="(itemPr, i2) in paraToList(pr.description)"
                        :key="i2"
                      >
                        <feather-icon
                          icon="ArrowRightCircleIcon"
                          :style="{ color: colorObj }"
                          svgClasses="stroke-current w-4 h-4"
                        />
                        {{ itemPr }}
                      </li>
                    </ul>
                  </div>
                  <h2 :style="{ color: colorObj }">{{ ch.title }}</h2>
                  <h3>{{ ch.company }}</h3>
                  <h4 v-if="ch.startDate">
                    <span v-if="ch.startDate">{{
                      formatDate(ch.startDate)
                    }}</span>
                    <span v-if="ch.startDate"> - </span>
                    <span v-if="ch.currentlyActive">Present</span>
                    <span v-else-if="ch.endDate">{{
                      formatDate(ch.endDate)
                    }}</span>
                  </h4>
                  <p></p>
                  <ul>
                    <li
                      v-for="(item, i2) in paraToList(ch.description)"
                      :key="i2"
                    >
                      <feather-icon
                        icon="ArrowRightCircleIcon"
                        :style="{ color: colorObj }"
                        svgClasses="stroke-current w-4 h-4"
                      />
                      {{ item }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div
              v-if="
                editorData.educationalQualifications &&
                editorData.educationalQualifications.length
              "
              class="education"
            >
              <img
                class="mr-3 float-left"
                src="@/assets/images/icons/editor-icons/inactive/educational-qualifications.svg"
              />
              <div class="content-title">
                {{ $t("editor.template.prestige.educationalQualifications") }}
              </div>
              <div
                v-for="(ch, index) in editorData.educationalQualifications"
                :key="index"
                class="main-box"
              >
                <div v-if="ch.degreeCertification">
                  <h2 :style="{ color: colorObj }">
                    {{ ch.degreeCertification }}
                    <span v-if="ch.grade">({{ ch.grade }})</span>
                  </h2>
                  <h3>{{ ch.organization }}</h3>
                  <h4>
                    <span v-if="ch.startDate">{{
                      formatDate(ch.startDate)
                    }}</span
                    ><span v-if="ch.startDate && ch.endDate"> - </span
                    ><span v-if="ch.endDate">{{ formatDate(ch.endDate) }}</span>
                  </h4>
                  <p>{{ ch.description }}</p>
                </div>
              </div>
            </div>

            <div
              v-if="editorData.projects && editorData.projects.length"
              class="education"
            >
              <img
                class="mr-3 float-left"
                src="@/assets/images/icons/editor-icons/inactive/projects.svg"
              />
              <div class="content-title">Projects</div>
              <div class="main-box project-container">
                <vs-row class="columns">
                  <div
                    v-for="(project, index) in editorData.projects"
                    :key="index"
                    class="w-full md:w-1/3 project-details"
                  >
                    <div v-if="project.title">
                      <div
                        v-if="project.projectPictureUrl"
                        class="items-center"
                      >
                        <img
                          style="height: 150px; width: 100%"
                          class="portfolio-img mb-4"
                          crossorigin="anonymous"
                          :src="
                            constants.s3Bucket +
                            '/editor/project-pictures/' +
                            project.projectPictureUrl
                          "
                        />
                      </div>
                      <h3>{{ project.title }}</h3>
                      <p class="text-justify">
                        {{ project.description }}
                      </p>
                    </div>
                  </div>
                </vs-row>
              </div>
            </div>

            <!-- CONSULTING OFFERS -->
            <div
  v-if="offers && offers.length > 0"
  class="main-box project-container"
  style="
    background: #fff;
    border: 1px solid #E5E7EB;
    border-radius: 12px;
    padding: 18px;
  "
>
  <!-- ============================= -->
  <!-- SECTION HEADER -->
  <!-- ============================= -->
  <div
    style="
      display: flex;
      align-items: center;
      margin-bottom: 16px;
    "
  >
    <feather-icon
      icon="BriefcaseIcon"
      svg-classes="w-5 h-5"
      style="
        margin-right: 8px;
        color: #6B7280;
      "
    />

    <h3
      style="
        margin: 0;
        font-size: 17px;
        font-weight: 700;
        color: #374151;
        letter-spacing: 0.2px;
      "
    >
      CONSULTING OFFERS
    </h3>
  </div>


  <!-- ============================= -->
  <!-- OFFER GRID -->
  <!-- ============================= -->
  <vs-row
    class="columns"
    style="margin-left: -8px; margin-right: -8px;"
  >

    <!-- EACH OFFER -->
    <div
      v-for="(offer, index) in offers"
      :key="index"
      class="w-full md:w-1/3 project-details"
      style="
        padding-left: 8px;
        padding-right: 8px;
        margin-bottom: 16px;
      "
    >

      <div
        v-if="offer.title"
        style="
          background: #FFFFFF;
          border: 1px solid #E5E7EB;
          border-radius: 12px;
          overflow: hidden;
          height: 100%;
          transition: all 0.2s ease;
        "
      >

        <!-- ============================= -->
        <!-- COLOR ACCENT BANNER -->
        <!-- ============================= -->
        <div
          style="
            width: 100%;
            height: 12px;
          "
          :style="{ backgroundColor: offer.profileColor || '#10b981' }"
        ></div>


        <!-- ============================= -->
        <!-- CARD CONTENT -->
        <!-- ============================= -->
        <div
          style="
            padding: 15px 16px 16px 16px;
          "
        >

          <!-- BEST FIT -->
          <div
            v-if="offer.bestFitFor"
            style="
              display: inline-block;
              font-size: 9px;
              font-weight: 700;
              text-transform: uppercase;
              letter-spacing: 0.6px;
              color: #6B7280;
              background: #F3F4F6;
              padding: 4px 7px;
              border-radius: 5px;
              margin-bottom: 8px;
            "
          >
            {{ offer.bestFitFor }}
          </div>


          <!-- OFFER TITLE -->
          <h3
            :style="{ color: colorObj }"
            style="
              margin: 0 0 8px 0;
              font-size: 17px;
              font-weight: 700;
              line-height: 1.3;
            "
          >
            {{ offer.title }}
          </h3>


          <!-- VALUE PROMISE -->
          <div
            v-if="offer.valuePromise"
            style="
              font-size: 11px;
              line-height: 1.5;
              color: #6B7280;
              margin-bottom: 14px;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
            "
          >
            {{ offer.valuePromise }}
          </div>


          <!-- ============================= -->
          <!-- PRICE / DELIVERY / FORMAT -->
          <!-- ============================= -->
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 10px 0;
              border-top: 1px solid #F3F4F6;
              border-bottom: 1px solid #F3F4F6;
              margin-bottom: 13px;
            "
          >

            <!-- PRICE -->
            <div>

              <div
                style="
                  font-size: 18px;
                  line-height: 1;
                  font-weight: 800;
                  color: #111827;
                "
              >
                {{ offer.price ? '€ ' + offer.price : 'Custom' }}
              </div>

              <div
                v-if="offer.paymentBasis"
                style="
                  font-size: 9px;
                  color: #9CA3AF;
                  margin-top: 4px;
                "
              >
                {{ offer.paymentBasis }}
              </div>

            </div>


            <!-- DELIVERY + FORMAT -->
            <div
              style="
                text-align: right;
              "
            >

              <div
                v-if="offer.deliveryWindow"
                style="
                  font-size: 10px;
                  font-weight: 700;
                  color: #374151;
                "
              >
                {{ offer.deliveryWindow }}
              </div>

              <div
                v-if="offer.format"
                style="
                  font-size: 9px;
                  color: #6B7280;
                  margin-top: 3px;
                "
              >
                {{ offer.format }}
              </div>

            </div>

          </div>


          <!-- ============================= -->
          <!-- WHAT YOU'LL RECEIVE -->
          <!-- ============================= -->
          <div
            v-if="offer.deliverables && offer.deliverables.length"
            style="
              margin-bottom: 13px;
            "
          >

            <div
              style="
                font-size: 10px;
                font-weight: 700;
                color: #374151;
                margin-bottom: 7px;
              "
            >
              What you'll receive
            </div>


            <!-- SHOW MAX 3 -->
            <div
              v-for="(item, i) in offer.deliverables.slice(0, 3)"
              :key="i"
              style="
                display: flex;
                align-items: flex-start;
                margin-bottom: 5px;
              "
            >

              <span
                style="
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  width: 14px;
                  height: 14px;
                  min-width: 14px;
                  border-radius: 50%;
                  background: #ECFDF5;
                  color: #16A34A;
                  font-size: 9px;
                  font-weight: 700;
                  margin-right: 6px;
                  margin-top: 1px;
                "
              >
                ✓
              </span>

              <span
                style="
                  font-size: 10px;
                  line-height: 1.35;
                  color: #4B5563;
                "
              >
                {{ item }}
              </span>

            </div>


            <!-- MORE DELIVERABLES -->
            <div
              v-if="offer.deliverables.length > 3"
              style="
                font-size: 9px;
                font-weight: 600;
                color: #6B7280;
                margin-top: 6px;
                margin-left: 20px;
              "
            >
              + {{ offer.deliverables.length - 3 }} more
            </div>

          </div>


          <!-- ============================= -->
          <!-- SMALL TRUST BADGES -->
          <!-- ============================= -->
          <div
            style="
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              gap: 5px;
              margin-top: 5px;
            "
          >

            <!-- RESPONSE -->
            <span
              v-if="offer.responseTime"
              style="
                display: inline-flex;
                align-items: center;
                background: #F9FAFB;
                border: 1px solid #E5E7EB;
                color: #6B7280;
                font-size: 8px;
                font-weight: 600;
                padding: 4px 7px;
                border-radius: 20px;
              "
            >
              {{ offer.responseTime }} response
            </span>


            <!-- VALUE EXCHANGE -->
            <span
              v-if="offer.valueExchangeAccepted"
              style="
                display: inline-flex;
                align-items: center;
                background: #F0FDF4;
                border: 1px solid #DCFCE7;
                color: #15803D;
                font-size: 8px;
                font-weight: 600;
                padding: 4px 7px;
                border-radius: 20px;
              "
            >
              ✓ Value exchange
            </span>

          </div>

        </div>
      </div>
    </div>
  </vs-row>
</div>

            <div v-if="editorData.personality">
              <div
                v-if="savedPersonalityTraits && savedPersonalityTraits.length"
              >
                <div v-if="organizationSlug === 'default'">
                  <div
                    v-if="
                      editorData.personality.broadcastPersonality !==
                      'dont-broadcast-my-personality'
                    "
                    class="education"
                  >
                    <img
                      class="mr-3 float-left"
                      src="@/assets/images/icons/editor-icons/inactive/personality.svg"
                    />
                    <div class="content-title">
                      {{ $t("editor.template.prestige.personalityTraits") }}
                    </div>
                    <div class="main-box">
                      <div
                        v-if="
                          editorData.personality.broadcastPersonality ===
                          'show-personality-statements'
                        "
                      >
                        <!-- show statements -->
                        <vs-row class="columns">
                          <ul
                            v-if="editorData.personality.personalityStatements"
                          >
                            <li
                              v-for="(itemPr, i2) in paraToList(
                                editorData.personality.personalityStatements
                              )"
                              :key="i2"
                            >
                              <feather-icon
                                icon="ArrowRightCircleIcon"
                                :style="{ color: colorObj }"
                                svgClasses="stroke-current w-4 h-4"
                              />
                              {{ itemPr }}
                            </li>
                          </ul>
                          <ul v-else>
                            <li
                              v-for="(
                                personality, index
                              ) in savedPersonalityTraits"
                              :key="index"
                            >
                              <feather-icon
                                icon="ArrowRightCircleIcon"
                                :style="{ color: colorObj }"
                                svgClasses="stroke-current w-4 h-4"
                              />
                              {{
                                getPersonalityTraitById(personality.id)
                                  .iAmDescription
                              }}
                            </li>
                          </ul>
                        </vs-row>
                      </div>
                      <div v-else>
                        <vs-row class="columns">
                          <div
                            v-for="(
                              personality, index
                            ) in savedPersonalityTraits"
                            :key="index"
                            class="w-full px-2 md:w-1/3"
                          >
                            <div v-if="index < 6">
                              <div class="items-center">
                                <div
                                  v-if="
                                    editorData.personality
                                      .broadcastPersonality === 'show-cloud-tag'
                                  "
                                  class="mb-base"
                                >
                                  <!-- cloud tag -->
                                  <div
                                    class="cloud-tag"
                                    :style="{
                                      backgroundColor: colorSet[index],
                                    }"
                                  >
                                    <h3>
                                      {{
                                        getPersonalityTraitById(personality.id)
                                          .ability
                                      }}
                                    </h3>
                                  </div>
                                </div>
                                <div v-else class="mb-base">
                                  <!-- show icons -->
                                  <img
                                    style="height: 100px; width: auto"
                                    class="mb-4"
                                    :src="
                                      getPersonalityTraitById(personality.id)
                                        .pngIcon
                                    "
                                  />

                                  <h3>
                                    {{
                                      getPersonalityTraitById(personality.id)
                                        .ability
                                    }}
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </div>
                        </vs-row>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="organizationSlug === 'dpd-belux'">
                  <div
                    v-if="
                      editorData.personality.broadcastPersonalityDpdBelux !==
                      'dont-broadcast-my-personality'
                    "
                    class="education"
                  >
                    <img
                      class="mr-3 float-left"
                      src="@/assets/images/icons/editor-icons/inactive/personality.svg"
                    />
                    <div class="content-title">
                      {{ $t("editor.template.prestige.competency") }}
                    </div>
                    <div class="main-box">
                      <div
                        v-if="
                          editorData.personality
                            .broadcastPersonalityDpdBelux ===
                          'show-personality-statements'
                        "
                      >
                        <!-- show statements -->
                        <vs-row class="columns">
                          <ul
                            v-if="
                              editorData.personality
                                .personalityStatementsDpdBelux
                            "
                          >
                            <li
                              v-for="(itemPr, i2) in paraToList(
                                editorData.personality
                                  .personalityStatementsDpdBelux
                              )"
                              :key="i2"
                            >
                              <feather-icon
                                icon="ArrowRightCircleIcon"
                                :style="{ color: colorObj }"
                                svgClasses="stroke-current w-4 h-4"
                              />
                              {{ itemPr }}
                            </li>
                          </ul>
                          <ul v-else>
                            <li
                              v-for="(
                                personality, index
                              ) in savedPersonalityTraits"
                              :key="index"
                            >
                              <feather-icon
                                icon="ArrowRightCircleIcon"
                                :style="{ color: colorObj }"
                                svgClasses="stroke-current w-4 h-4"
                              />
                              {{
                                getPersonalityTraitById(personality.id)
                                  .description
                              }}
                            </li>
                          </ul>
                        </vs-row>
                      </div>
                      <div v-else>
                        <vs-row class="columns">
                          <div
                            v-for="(
                              personality, index
                            ) in savedPersonalityTraits"
                            :key="index"
                            class="w-full px-2 md:w-1/3"
                          >
                            <div v-if="index < 6">
                              <div class="items-center">
                                <div
                                  v-if="
                                    editorData.personality
                                      .broadcastPersonalityDpdBelux ===
                                    'show-cloud-tag'
                                  "
                                  class="mb-base"
                                >
                                  <!-- cloud tag -->
                                  <div
                                    class="cloud-tag"
                                    :style="{
                                      backgroundColor: colorSet[index],
                                    }"
                                  >
                                    <h3>
                                      {{
                                        getPersonalityTraitById(personality.id)
                                          .ability
                                      }}
                                    </h3>
                                  </div>
                                </div>
                                <div v-else class="mb-base">
                                  <!-- show icons -->
                                  <img
                                    style="height: 100px; width: auto"
                                    class="mb-4"
                                    :src="
                                      getPersonalityTraitById(personality.id)
                                        .pngIcon
                                    "
                                  />

                                  <h3>
                                    {{
                                      getPersonalityTraitById(personality.id)
                                        .ability
                                    }}
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </div>
                        </vs-row>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="organizationSlug === 'gala'">
                  <div
                    v-if="
                      editorData.personality.broadcastPersonalityGala !==
                      'dont-broadcast-my-personality'
                    "
                    class="education"
                  >
                    <img
                      class="mr-3 float-left"
                      src="@/assets/images/icons/editor-icons/inactive/personality.svg"
                    />
                    <div class="content-title">
                      {{ $t("editor.template.prestige.competency") }}
                    </div>
                    <div class="main-box">
                      <div
                        v-if="
                          editorData.personality.broadcastPersonalityGala ===
                          'show-personality-statements'
                        "
                      >
                        <!-- show statements -->
                        <vs-row class="columns">
                          <ul
                            v-if="
                              editorData.personality.personalityStatementsGala
                            "
                          >
                            <li
                              v-for="(itemPr, i2) in paraToList(
                                editorData.personality.personalityStatementsGala
                              )"
                              :key="i2"
                            >
                              <feather-icon
                                icon="ArrowRightCircleIcon"
                                :style="{ color: colorObj }"
                                svgClasses="stroke-current w-4 h-4"
                              />
                              {{ itemPr }}
                            </li>
                          </ul>
                          <ul v-else>
                            <li
                              v-for="(
                                personality, index
                              ) in savedPersonalityTraits"
                              :key="index"
                            >
                              <feather-icon
                                icon="ArrowRightCircleIcon"
                                :style="{ color: colorObj }"
                                svgClasses="stroke-current w-4 h-4"
                              />
                              {{
                                getPersonalityTraitById(personality.id)
                                  .description
                              }}
                            </li>
                          </ul>
                        </vs-row>
                      </div>
                      <div v-else>
                        <vs-row class="columns">
                          <div
                            v-for="(
                              personality, index
                            ) in savedPersonalityTraits"
                            :key="index"
                            class="w-full px-2 md:w-1/3"
                          >
                            <div v-if="index < 6">
                              <div class="items-center">
                                <div
                                  v-if="
                                    editorData.personality.broadcastPersGala ===
                                    'show-cloud-tag'
                                  "
                                  class="mb-base"
                                >
                                  <!-- cloud tag -->
                                  <div
                                    class="cloud-tag"
                                    :style="{
                                      backgroundColor: colorSet[index],
                                    }"
                                  >
                                    <h3>
                                      {{
                                        getPersonalityTraitById(personality.id)
                                          .ability
                                      }}
                                    </h3>
                                  </div>
                                </div>
                                <div v-else class="mb-base">
                                  <!-- show icons -->
                                  <img
                                    style="height: 100px; width: auto"
                                    class="mb-4"
                                    :src="
                                      getPersonalityTraitById(personality.id)
                                        .pngIcon
                                    "
                                  />

                                  <h3>
                                    {{
                                      getPersonalityTraitById(personality.id)
                                        .ability
                                    }}
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </div>
                        </vs-row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="userData.showCareerHistoryOnMap" class="education mb-0">
              <img
                class="mr-3 float-left"
                src="@/assets/images/icons/editor-icons/inactive/projects.svg"
              />
              <div class="content-title">
                {{
                  $t("editor.template.prestige.placesIHaveWorkedStudiedBefore")
                }}
              </div>
              <div class="main-box">
                <div class="columns">
                  <div>
                    <world-map :colorObj="colorObj" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vs-row>
      </div>
    </section>
  </div>
</template>

<script>
import constants from "@/constants";
import moment from "moment";
import * as imageToBase64 from "image-to-base64";
import StarRating from "vue-star-rating";
import WorldMap from "./WorldMap";
// import personalityData from "@/assets/data/personality.js";
import organizationConfig from "@/assets/data/organization-config.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import axios from "axios";

export default {
  components: { StarRating, WorldMap },
  data() {
    return {
      fetchedOffers: [],
      htmlToPdfOptions: {},
      constants,
      map: {
        defaultCountryFillColor: "white",
        highColor: this.colorObj,
        lowColor: this.colorObj,
        countryStrokeColor: "black",
      },
      visitedCountries: {
        US: 101,
        NZ: 101,
        UK: 101,
        IN: 103,
      },
      // personalityData,
      colorSet: [
        "#008000",
        "#3BA0BE",
        "#6859B4",
        "#E4D033",
        "#EA7526",
        "#C6211B",
        "#F36677",
        "#B3B3B3",
      ],
      userProfilePicture: null,
    };
  },
  computed: {
    authUserId() {
      return this.$store.state.auth.user ? this.$store.state.auth.user._id : null;
    },
    offers() {
      if (this.fetchedOffers && this.fetchedOffers.length > 0) {
        return this.fetchedOffers;
      }
      return (this.$store.state.editor && this.$store.state.editor.offers) || [];
    },
    userData() {
      return this.$store.state.users.data;
    },
    editorData() {
      return this.$store.state.editor;
    },
    extraCurricular() {
      return this.$store.state.editor.extraCurricular;
    },
    colorObj() {
      return this.userData.templateColorCode;
    },
    backgroundColorObj() {
      return { backgroundColor: this.userData.templateColorCode };
    },
    organizationSlug() {
      return this.$store.state.organization.organizationSlug;
    },
    locale() {
      return this.$i18n.locale;
    },
    personalityData() {
      return organizationConfig[this.organizationSlug].personalityTraits[
        this.locale
      ];
    },
    savedPersonalityTraits() {
      let personalityTraits = [];

      // For Dpd Belux
      if (this.organizationSlug === "dpd-belux") {
        if (
          !this.editorData.personality ||
          !this.editorData.personality.personalityTraitsDpdBelux ||
          !this.editorData.personality.personalityTraitsGala
        )
          return [];
        this.editorData.personality.personalityTraitsDpdBelux.forEach((pt) => {
          this.personalityData.forEach((pt2) => {
            if (pt.id === pt2.id) {
              personalityTraits.push(pt);
            }
          });
        });
      } else if (this.organizationSlug === "gala") {
        if (
          !this.editorData.personality ||
          !this.editorData.personality.personalityTraitsGala
        )
          return [];
        this.editorData.personality.personalityTraitsGala.forEach((pt) => {
          this.personalityData.forEach((pt2) => {
            if (pt.id === pt2.id) {
              personalityTraits.push(pt);
            }
          });
        });
      } else {
        if (
          !this.editorData.personality ||
          !this.editorData.personality.personalityTraits
        )
          return [];
        this.editorData.personality.personalityTraits.forEach((pt) => {
          this.personalityData.forEach((pt2) => {
            if (pt.id === pt2.id) {
              personalityTraits.push(pt);
            }
          });
        });
      }

      return personalityTraits;
    },
  },
  watch: {
    colorObj(newVal) {
      if (newVal) {
        this.map.highColor = newVal;
        this.map.lowColor = newVal;
        this.$forceUpdate();
      }
    },
    // 👉 ADD THIS WATCHER FOR THE OFFERS
    authUserId: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.fetchConsultingOffers();
        }
      }
    },
    // 👉 UPDATE YOUR USERDATA WATCHER
    userData: {
      deep: true, // This forces Vue to notice when data populates after a hard refresh!
      immediate: true,
      handler(newVal) {
        if (newVal && newVal._id) {
          // Fallback fetch just in case authUserId was slow
          this.fetchConsultingOffers();
          
          if (newVal.profilePictureUrl) {
            this.converImgToBase64(
              `${this.constants.s3Bucket}/editor/profile-pictures/${newVal.profilePictureUrl}`
            );
          }
        }
      }
    }
  },
  methods: {
    async fetchConsultingOffers() {
      // Safely grab the User ID directly from the store
      const userId = this.$store.state.auth.user ? this.$store.state.auth.user._id : null;
      if (!userId) return;
      
      try {
        const res = await axios.get(`https://parser.ai.getboarded.com/api/offers/${userId}`);
        if (res.data && res.data.status === 'success') {
          // 👉 USING $set GUARANTEES A SCREEN RE-RENDER
          this.$set(this, 'fetchedOffers', res.data.data);
        }
      } catch (err) {
        console.error("Failed to fetch consulting offers for Prestige:", err);
      }
    },
    async converImgToBase64(url) {
      try {
        // # is added for a fresh server load
        const data = await fetch(url + "?#" + new Date().getTime());
        // // console.log(data);
        const blob = await data.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64data = reader.result;
            this.userProfilePicture = base64data;
            // // console.log(this.userProfilePicture);
            resolve(base64data);
          };
        });
      } catch (err) {
        throw err;
      }
    },
    getPersonalityTraitById(id) {
      const p = this.personalityData.find((pd) => pd.id === id);
      return p;
    },
    async generatePDF() {
      // this.$refs.html2Pdf.generatePdf();

      /*html2pdf(this.$refs.prestigeDocument, {
					margin: 0,
					filename: `${this.userData.firstName}-${this.userData.lastName}.pdf`,
					image: { type: 'jpeg', quality: 0.98 },
					html2canvas: {scale: 4, dpi: 192, letterRendering: true },
					jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
          enableLinks: true,
          pagebreak: { mode: ['avoid-all'] },
				}).then(() => {
          this.$vs.loading.close();
        })*/

      const pdfName = `${this.userData.firstName}-${this.userData.lastName}.pdf`;
      const vsLoading = this.$vs.loading;

      await html2canvas(this.$refs.prestigeDocument).then(function (canvas) {
        var a = document.createElement("a");
        // toDataURL defaults to png, so we need to request a jpeg, then convert for file download.
        a.href = canvas.toDataURL("image/jpeg", 1.0);
        // a.download = 'somefilename.jpeg';
        // a.click();

        const img = new Image();
        img.onload = async function () {
          // // console.log(this.width + 'x' + this.height);
          let pdf = new jsPDF("p", "px", [this.width, this.height]);
          if (this.width > this.height) {
            pdf = new jsPDF("l", "px", [this.width, this.height]);
          }
          await pdf.addImage(a.href, "JPEG", 0, 0, this.width, this.height);
          await pdf.save(pdfName);
          vsLoading.close();
        };
        img.src = a.href;
      });
    },
    startPagination() {
      // this.$vs.loading();
    },
    onProgressDownload(ev) {},
    hasDownloaded() {
      this.$vs.loading.close();
    },
    async imgToBase64(img) {
      let imgRes = "";
      await imageToBase64(img)
        .then((res) => {
          imgRes = res;
          return res;
        })
        .catch((err) => {
          throw err;
        });

      return imgRes;
    },
    paraToList(para) {
      if (para) {
        let lst = para.match(/[^\.!\?]+[\.!\?]+/g);
        if (lst && lst.length) {
          return lst;
        } else {
          return [para];
        }
      }
      return [];
    },
    formatDate(date) {
      return moment(date).format("MMM YYYY");
    },
    async copyProfile(discordProfile) {
      await navigator.clipboard.writeText(discordProfile);
      this.$vs.notify({
        text: "Discord username is copied to clipboard",
        iconPack: "feather",
        icon: "icon-check-circle",
        color: "success",
        fixed: false,
      });
    },
  },
  mounted() {
    this.$root.$on("downloadResume", () => {
      this.generatePDF();
    });

    // 👉 ADD THIS LINE
    this.fetchConsultingOffers();

    // convert profile picture to base64
    if (this.userData && this.userData.profilePictureUrl) {
      this.converImgToBase64(
        `${this.constants.s3Bucket}/editor/profile-pictures/${this.userData.profilePictureUrl}`
      );
    }
  },
};
</script>

<style scoped>
/* .vue-html2pdf >>> .layout-container {
  background: none !important;
  position: initial !important;
  height: auto !important;
  width: auto !important;
} */

/*@import url("css/style.css");
@import url("css/responsive.css");

.column {
  float: left;
  margin: 0 2.5% 1em 0;
  width: 31.6%;
}

.column:nth-child(3n) {
  margin-right: 0;
}

.column:nth-child(3n + 1) {
  clear: left;
}

.column img {
  width: 100%;
  height: auto;
  margin-bottom: 12px;
}

@import url("css/lightbox.min.css");*/

@charset "utf-8";
/* CSS Document */

* {
  margin: 0;
  padding: 0;
}
body {
  background-color: #ebebeb;
  font-family: "Roboto", sans-serif;
  color: #483d41;
  font-weight: 400;
}
h1,
h2,
h3,
h4 {
  font-weight: 400;
}
a {
  transition: all 0.3s ease;
}
p {
  font-size: 14px;
  line-height: 20px;
}
.wrapper {
  max-width: 1170px;
  margin: auto;
  padding: 0 20px;
}
h2.profile_name {
  text-shadow: 0 0 8px black;
}
.title h2 {
  font-weight: 600;
}
.sidebar {
  width: 25%;
  margin-right: 2%;
  float: left;
  background-color: #fff;
}

.content {
  width: 73%;
  float: left;
}
.profile-pic {
  position: relative;
}
.profile-pic img {
  width: 100%;
  height: auto;
  vertical-align: bottom;
}

.title {
  color: #fff;
  padding: 1.25em;
}
.heading-image {
  position: relative;
}
.summary {
  /*background-color: #25725e;*/
  color: #fff;
  padding: 1.25em;
}
.sidebar-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #fff;
  text-transform: uppercase;
}
.content-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 25px;
  text-transform: uppercase;
}
.content-title i {
  margin-right: 12px;
}
.contact {
  color: #fff;
  padding: 1.25em;
  overflow: hidden;
}
.address {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 10px;
}
.number {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 10px;
}
.email {
  font-size: 15px;
  font-weight: 500;
  overflow-wrap: break-word;
}
.social {
  margin-top: 15px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.btn-social-custom {
  display: block;
  width: 25px;
  float: left;
  height: 20px;
  padding: 10px;
  text-align: center;
  color: white;
  font-weight: bold;
  transition: all 0.4s ease;
  margin-right: 2px;
  margin-top: 3px;
  /*background-color: #73aa55;*/
}
.btn-social-custom:hover {
  /*background-color: #59903a;*/
}
/*.social-box{
width:24%;
background-color:#73aa55;
text-align:center;
padding:10px 0;
float:left;
cursor:pointer;
margin-right:1px;
margin-bottom:1px;
transition:all 0.3s ease;
}*/

/*.social-box {
color:#FFF;
background-color:#59903a;
}*/

/*.social-box:hover{*/
/*background-color:#59903a;*/
/*border-radius: 5px;*/
/*background-color:#73aa55;*/
/*}*/
.hobbies-box {
  text-align: center;
  width: 33%;
  float: left;
  margin-bottom: 16px;
}
.hobbies-box i {
  color: #fff;
}
.hobbies-box h3 {
  margin-top: 10px;
  color: #fff;
  font-weight: 500 !important;
  font-size: 13px !important;
}
.skills {
  padding: 1.25em;
  overflow: hidden;
}
.awards {
  padding: 20px;
  /*background-color: #25725e;*/
}
.awards ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.awards ul li {
  margin-bottom: 15px;
  font-size: 12px;
  color: #fff;
  font-weight: 500;
  padding: 2px 0;
}
.awards ul li i {
  margin-right: 8px;
}
.awards ul li span {
  margin-top: 5px;
  display: block;
  overflow: hidden;
}
.skills ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
  overflow: hidden;
}
.skills ul li {
  margin-bottom: 5px;
  font-size: 12px;
  color: #fff;
  font-weight: 500;
  /*padding: 8px 15px;*/
  padding: 8px 15px 8px 0;
  /*background-color: #429e86;*/
  float: left;
  margin-right: 5px;
}
.experience {
  padding: 1.875em;
  background-color: #fff;
  margin-bottom: 1.25em;
}
.education {
  padding: 1.875em;
  background-color: #fff;
  margin-bottom: 1.25em;
  overflow: hidden;
}
.main-box {
  border-bottom: 1px solid #f5f5f5;
  margin-bottom: 20px;
  padding-bottom: 20px;
  display: inline-block;
  width: 100%;
}
.main-box:last-child {
  border-bottom: 0;
  margin-bottom: 0;
  padding-bottom: 0;
}
.main-box h2 {
  font-size: 22px;
  margin-bottom: 6px;
  /*color: #6fa909;*/
  font-weight: 300;
}
.main-box h3 {
  font-size: 16px;
  margin-bottom: 6px;
  font-weight: 600;
}
.main-box h3 .comma-before:not(:empty):before {
  content: ", ";
}
.main-box h4 {
  font-size: 13px;
  margin-bottom: 6px;
}
.main-box p {
  font-size: 16px;
  margin-bottom: 10px;
}
.main-box ul {
  list-style-type: none;
}
.main-box ul li {
  margin-bottom: 5px;
  font-size: 14px;
  padding: 2px;
  font-weight: 500;
}
.main-box ul li i {
  margin-right: 6px;
  /*color: #6fa909;*/
}
.ref-pic {
  width: 80px;
  float: left;
  margin-right: 20px;
}
.ref-pic img {
  width: 100%;
  height: auto;
}
.name-field {
  margin-bottom: 10px;
}
input[type="text"] {
  width: 90%;
  border: 1px solid #ddd;
  display: inline-block;
  height: 35px;
  padding: 0 12px;
  font-family: Arial;
}
input[type="email"] {
  width: 90%;
  border: 1px solid #ddd;
  display: inline-block;
  height: 35px;
  padding: 0 12px;
  font-family: Arial;
}
textarea {
  width: 100%;
  border: 1px solid #ddd;
  display: inline-block;
  height: 60px;
  padding: 12px;
  font-family: Arial;
}
.submit-button {
  text-align: right;
  margin-top: 10px;
}
.submit-button input[type="submit"] {
  /*background: #639c43;*/
  border-radius: 2px;
  font-family: Arial;
  color: #ffffff;
  font-size: 13px;
  padding: 10px 20px 10px 20px;
  text-decoration: none;
  border: none;
  cursor: pointer;
  font-weight: bold;
}
.submit-button input[type="submit"]:hover {
  text-decoration: none;
  background: #2082c4;
}

/* Hover Animation */
.portfolio-img {
  position: relative;

  min-height: 150px !important;
  background-size: cover !important;
  background-position: center !important;
}
.portfolio-img img {
  display: block;
  max-width: 100%;
  height: auto;
}
.port-hover {
  content: "";
  background: rgba(119, 171, 89, 0.8);
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
  transform: scale(0, 0);
  transition: all 0.4s ease-in 0s;
  -webkit-transform: scale(0, 0);
  opacity: 0;
}
.portfolio-img:hover .port-hover {
  opacity: 1;
  transform: scale(1, 1);
  -webkit-transform: scale(1, 1);
}
.plus-link {
  display: inline-block;
  height: 40px;
  position: absolute;
  width: 40px;
  left: 44%;
  top: 40%;
}
.pin:hover .plus-link::after {
  height: 1px;
  left: 0;
  top: 50%;
  width: 100%;
}
.column:hover .plus-link::after {
  height: 1px;
  left: 0;
  top: 50%;
  width: 100%;
}
.plus-link::before,
.plus-link::after {
  background-color: #fff;
  content: "";
  display: block;
  height: 1px;
  left: 50%;
  position: absolute;
  top: 50%;
  width: 1px;
}
.column:hover .plus-link::before {
  height: 100%;
  left: 50%;
  top: 0;
  width: 1px;
}
.plus-link::before,
.plus-link::after {
  background-color: #fff;
  content: "";
  display: block;
  height: 1px;
  left: 50%;
  position: absolute;
  top: 50%;
  width: 1px;
}
.porfolio-page .plus-link {
  left: 44%;
  top: 40%;
}
.portfolio-img:hover .port-hover a {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

@charset "utf-8";
/* CSS Document */

@charset "utf-8";
/* CSS Document */

@media (max-width: 1200px) {
}
/* I-pad Landscape */
@media (max-width: 1024px) {
}
/* Google Nexus 7 Landscape */
@media (max-width: 992px) {
}
/* I-pad Portrait */
@media (max-width: 768px) {
  .sidebar {
    width: 100%;
    margin-right: 0;
  }
  .content {
    width: 100%;
    margin-top: 20px;
  }
}
@media (max-width: 767px) {
}

/* I-phone 6 Plump Landscape */
@media (max-width: 736px) {
}
/* I-phone 6 Landscape */
@media (max-width: 667px) {
}
/* HTC One Landscape */
@media (max-width: 640px) {
}
/* Google Nexus 7 Portrait */
@media (max-width: 603px) {
}
/* Google Nexus 4 Landscape */
@media (max-width: 600px) {
}
/* I-phone 5 Landscape */
@media (max-width: 568px) {
}
/* I-phone 4 Landscape */
@media (max-width: 480px) {
}
/* Nokia Lumia Portrait */
@media (max-width: 460px) {
}
/* I-phone 6 Plump Portrait */
@media (max-width: 414px) {
}
/* I-phone 6 Portrait */
@media (max-width: 375px) {
}
/* HTC One Portrait */
@media (max-width: 360px) {
}
/* I-phone 5 Portrait */
@media (max-width: 320px) {
}
/* Small mobile */
@media (max-width: 240px) {
}

.column {
  float: left;
  margin: 0 2.5% 1em 0;
  width: 31.6%;
}

.column:nth-child(3n) {
  margin-right: 0;
}

.column:nth-child(3n + 1) {
  clear: left;
}

.column img {
  width: 100%;
  height: auto;
  margin-bottom: 12px;
}

.lb-loader,
.lightbox {
  text-align: center;
  line-height: 0;
}
body:after {
  content: url(images/close.png) url(images/loading.gif) url(images/prev.png)
    url(images/next.png);
  display: none;
}
.lb-dataContainer:after,
.lb-outerContainer:after {
  content: "";
  clear: both;
}
body.lb-disable-scrolling {
  overflow: hidden;
}
.lightboxOverlay {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  background-color: #000;
  filter: alpha(Opacity=80);
  opacity: 0.8;
  display: none;
}
.lightbox {
  position: absolute;
  left: 0;
  width: 100%;
  z-index: 10000;
  font-weight: 400;
}
.lightbox .lb-image {
  display: block;
  height: auto;
  max-width: inherit;
  border-radius: 3px;
}
.lightbox a img {
  border: none;
}
.lb-outerContainer {
  position: relative;
  background-color: #fff;
  width: 250px;
  height: 250px;
  margin: 0 auto;
  border-radius: 4px;
}
.lb-loader,
.lb-nav {
  position: absolute;
  left: 0;
}
.lb-outerContainer:after {
  display: table;
}
.lb-container {
  padding: 4px;
}
.lb-loader {
  top: 43%;
  height: 25%;
  width: 100%;
}
.lb-cancel {
  display: block;
  width: 32px;
  height: 32px;
  margin: 0 auto;
  background: url(images/loading.gif) no-repeat;
}
.lb-nav {
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 10;
}
.lb-container > .nav {
  left: 0;
}
.lb-nav a {
  outline: 0;
  background-image: url(data:image/gif;base64,R0lGODlhAQABAPAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==);
}
.lb-next,
.lb-prev {
  height: 100%;
  cursor: pointer;
  display: block;
}
.lb-nav a.lb-prev {
  width: 34%;
  left: 0;
  float: left;
  background: url(images/prev.png) left 48% no-repeat;
  filter: alpha(Opacity=0);
  opacity: 0;
  -webkit-transition: opacity 0.6s;
  -moz-transition: opacity 0.6s;
  -o-transition: opacity 0.6s;
  transition: opacity 0.6s;
}
.lb-nav a.lb-prev:hover {
  filter: alpha(Opacity=100);
  opacity: 1;
}
.lb-nav a.lb-next {
  width: 64%;
  right: 0;
  float: right;
  background: url(images/next.png) right 48% no-repeat;
  filter: alpha(Opacity=0);
  opacity: 0;
  -webkit-transition: opacity 0.6s;
  -moz-transition: opacity 0.6s;
  -o-transition: opacity 0.6s;
  transition: opacity 0.6s;
}
.lb-nav a.lb-next:hover {
  filter: alpha(Opacity=100);
  opacity: 1;
}
.lb-dataContainer {
  margin: 0 auto;
  padding-top: 5px;
  width: 100%;
  -moz-border-radius-bottomleft: 4px;
  -webkit-border-bottom-left-radius: 4px;
  border-bottom-left-radius: 4px;
  -moz-border-radius-bottomright: 4px;
  -webkit-border-bottom-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.lb-dataContainer:after {
  display: table;
}
.lb-data {
  padding: 0 4px;
  color: #ccc;
}
.lb-data .lb-details {
  width: 85%;
  float: left;
  text-align: left;
  line-height: 1.1em;
}
.lb-data .lb-caption {
  font-size: 13px;
  font-weight: 700;
  line-height: 1em;
}
.lb-data .lb-number {
  display: block;
  clear: left;
  padding-bottom: 1em;
  font-size: 12px;
  color: #999;
}
.lb-data .lb-close {
  display: block;
  float: right;
  width: 30px;
  height: 30px;
  background: url(images/close.png) top right no-repeat;
  text-align: right;
  outline: 0;
  filter: alpha(Opacity=70);
  opacity: 0.7;
  -webkit-transition: opacity 0.2s;
  -moz-transition: opacity 0.2s;
  -o-transition: opacity 0.2s;
  transition: opacity 0.2s;
}
.lb-data .lb-close:hover {
  cursor: pointer;
  filter: alpha(Opacity=100);
  opacity: 1;
}

/**
  Custom for template
*/

.cloud-tag {
  padding: 8px 10px;
  background-color: blue;
  border-radius: 8px;
}

.cloud-tag h3 {
  color: white !important;
  margin: 0 !important;
}
.social-icon {
  width: 2em;
  cursor: pointer;
  filter: brightness(0) invert(1);
}
.skype-icon {
  width: 2.375em;
}
.project-container {
  margin: 0 -0.5em !important;
}
.project-details {
  padding: 0 0.5em !important;
}
.icon-container {
  float: left;
  margin-right: 1em;
}

@media only screen and (max-width: 600px) {
  .title {
    padding: 1em;
  }
  .title h2 {
    font-size: 1.5em;
  }
  .summary {
    padding: 1em;
  }
  .contact {
    padding: 1em;
  }
  .skills {
    padding: 1em;
  }
  .experience {
    padding: 1em;
  }
  .education {
    padding: 1em;
  }
  .icon-container {
    margin-right: 0.35em;
  }
  .social-icon {
    width: 1.5em;
  }
  .skype-icon {
    width: 1.85em;
  }
}
</style>
